import { IOperator } from '../types/IOperator';
import { normalizeOperatorNaming } from '../lib/operatorGroup';

export default class Operator implements IOperator {
    id: number;

    name: string;

    cover: string;

    nameRu: string | null;

    constructor(operator: IOperator, imagesDomain: string) {
        const { id, name, nameRu } = normalizeOperatorNaming(operator);
        this.id = id;
        this.name = name;
        this.nameRu = nameRu;
        this.cover = `${imagesDomain}/photos/operator/${this.id}.png`;
    }
}